// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2fC2n","textonly":"button_textonly__2KsTG","empty":"button_empty__3XT-Y","border":"button_border__FkXpC"};